import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { resetBlock } from '../saleJetBlockSlice';
import FailureScreen from '../../../Shared/FailureScreen/FailureScreen';
import InternetOrderError from '../Partials/InternetOrderError/InternetOrderError';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const ErrorPage = (props) => {
  const isFiberSale = props.saleType === 'internet';

  useEffect(() => {
    gtag4({
      event: `${props.saleType}_ErrorMessage`,
      error: props.error.description,
      action: 'ErrorMessage',
    });
  }, []);

  function handleErrorPageClose() {
    props.resetBlock();
    const path = window.location.pathname;
    window.location.replace(path);
  }

  if (isFiberSale) {
    return (
      <div className='slideAnimation internet-error-page'>
        <InternetOrderError onClose={handleErrorPageClose} />
      </div>
    );
  }

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content'>
        <FailureScreen
          errorId={props.error.id}
          description={props.error.description}
          onclick={handleErrorPageClose}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.saleJetBlock.errorPage,
    saleType: state.saleJetBlock.saleType,
    //other states
  };
};

const mapDispatchToProps = {
  resetBlock
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);